import React from 'react';
import ExactDateFilter from '@root/src/app/designSystem/dateFilter/exactDateFilter';
import Label from '@app/common/Label';
import FormGroup from '@app/common/FormGroup';
import Select from '@app/common/Select';
import { fullHourOptions, minutesOptions, SelectOptionI } from '@app/utils';
import { StyledDateContainer, StyledTimeContainer } from './styles';
import { onDateChangeType } from '@designSystem/dateFilter/types';
import { NullableString } from '@app/common/types';
import { ValueType } from 'react-select';

interface PropsI {
  dateLabel: string;
  timeLabel: string;
  date: NullableString;
  onDateChange: onDateChangeType;
  onHoursChange: (value: SelectOptionI) => void;
  hours: SelectOptionI;
  onMinutesChange: (value: SelectOptionI) => void;
  minutes: SelectOptionI;
  testId?: string;
  errorMessage?: boolean;
}

const DateField = ({
  dateLabel,
  timeLabel,
  date,
  onDateChange,
  onHoursChange,
  hours,
  onMinutesChange,
  minutes,
  testId,
  errorMessage,
}: PropsI): React.ReactElement => {
  const handleHoursChange = (
    selected: ValueType<{ label: string; value: string }, false>
  ): void => {
    if (selected) {
      onHoursChange(selected);
    }
  };

  const handleMinutesChange = (
    selected: ValueType<{ label: string; value: string }, false>
  ): void => {
    if (selected) {
      onMinutesChange(selected);
    }
  };

  return (
    <StyledDateContainer>
      <FormGroup data-testid={testId ? `health-check-add-${testId}-date` : ''}>
        <Label>{dateLabel}</Label>
        <ExactDateFilter
          inputWidth={248}
          value={date}
          onDateChange={onDateChange}
          maxDate={Date.now()}
          data-testid={testId}
          errorMessage={errorMessage}
        />
      </FormGroup>
      <FormGroup data-testid={testId ? `health-check-add-${testId}-time` : ''}>
        <Label>{timeLabel}</Label>
        <StyledTimeContainer>
          <Select
            options={fullHourOptions}
            placeholder="00:00"
            onChange={handleHoursChange}
            value={hours as SelectOptionI}
            className="drop-down"
            error={errorMessage}
          />
          <Select
            options={minutesOptions}
            placeholder="00:00"
            onChange={handleMinutesChange}
            value={minutes as SelectOptionI}
            className="drop-down"
            error={errorMessage}
          />
        </StyledTimeContainer>
      </FormGroup>
    </StyledDateContainer>
  );
};

export default DateField;
